import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTabStore = defineStore('tab', () => {
  const tabs = ref<Record<string, number | string>>({});

  function setTab ({ uuid, index }: { uuid: string, index: number | string }) {
    tabs.value[uuid] = index;
  }
  function removeTab ({ uuid }: { uuid: string }) {
    if (uuid in tabs.value) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete tabs.value[uuid];
    }
  }
  return {
    tabs,
    setTab,
    removeTab,
  };
});
